// extracted by mini-css-extract-plugin
export default {"header":"header-oD91j","body":"body-oSE5c","classesList":"classesList-CHqAi","classRow":"classRow-CBfic"};